module.exports = "https://static.wmbcdn.com/uniweb/images/2d91d4036293e3fa736a322b1c00664b.svg";